var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[(_vm.Show)?_c('a-progress',{attrs:{"percent":Number(_vm.percentage)}}):_vm._e(),_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"text"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }